import { CREATEPASSWORD, EMAILCONFIRMATION } from "../../routes/routePaths";
import { baseUrl } from "../../utils/constants";
import { client } from "../client";
import {
  ACTIVATEUSER,
  BULKINVITEUSERS,
  CREATEGROUP,
  DEACTIVATEUSER,
  GETDISTRIBUTIONFORWARDS,
  GETFORWARDSRECIPIENTS,
  GETLITEUSERS,
  GETMANDATORYMESSAGES,
  GETMANDATORYREPLYMESSAGES,
  GETMESSAGERECIPIENTSSTATS,
  GETMESSAGESTATISTICS,
  GETREPLYRECIPIENTS,
  GETUSERANALYTICS,
  GETUSERMETRICS,
  GETUSERSFORROLE,
  REGISTER,
  USERDETAILS,
} from "../endpoints";

export const getUsers = async ({
  page,
  size,
  q,
  rioIds = [],
  rankIds = [],
  assemblyConstituencyIds = [],
  zoneIds = [],
  employeeId,
  activeUsers = false,
}: {
  page: number;
  size: number;
  q: string;
  rioIds?: number[];
  rankIds?: number[];
  assemblyConstituencyIds?: number[];
  zoneIds?: number[];
  employeeId?: number;
  activeUsers?: boolean;
}) => {
  const response = await client.get(`${baseUrl}/users/grid`, {
    params: {
      page,
      size,
      q,
      rankIds,
      assemblyConstituencyIds,
      zoneIds,
      rioIds,
      employeeId,
      activeUsers,
    },
  });
  return response;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const registerUser = async ({ newUser }: { newUser: any }) => {
  const response = await client.post(`${baseUrl}${REGISTER}`, newUser);
  return response;
};

export const isUserPasswordCreated = async ({ token }: { token: string }) => {
  const response = await client.post(`${baseUrl}${EMAILCONFIRMATION}`, {
    token,
  });
  return response;
};

export const createPassword = async ({
  token,
  newPassword,
}: {
  token: string;
  newPassword: string;
}) => {
  const response = await client.post(
    `${baseUrl}${CREATEPASSWORD}?Token=${token}&NewPassword=${newPassword}`
  );
  return response;
};

export const getUserMetrics = async () => {
  const response = await client.get(`${baseUrl}${GETUSERMETRICS}`);
  return response;
};

export const getUserForRole = async ({
  role,
  page,
  size,
  q,
}: {
  role: number;
  page: number;
  size: number;
  q: string;
}) => {
  const response = await client.get(
    `${baseUrl}/policies/${role}${GETUSERSFORROLE}`,
    {
      params: {
        page,
        size,
        q,
      },
    }
  );
  return response;
};

export const createGroupForUsers = async ({
  groupName,
  memberUserIds,
}: {
  groupName: string;
  memberUserIds: number[];
}) => {
  const response = await client.post(`${baseUrl}${CREATEGROUP}`, {
    groupName,
    memberUserIds,
  });
  return response;
};

export const getUserById = async (userId: number) => {
  const response = await client.get(`${baseUrl}${USERDETAILS}/${userId}`);
  return response.data;
};

export const updateUser = async (updatedUserData: {
  userId: number;
  fullName: string;
  mobileNo: string;
  rankId: number;
  policeStation: string;
  zoneId: number;
  location: string;
  roleId: number;
  assemblyConstituencyId: number;
}) => {
  const response = await client.put(
    `${baseUrl}${USERDETAILS}/${updatedUserData.userId}`,
    updatedUserData
  );
  return response.data;
};

export const getUserAnalytics = async ({
  userId,
  fromDate,
  toDate,
}: {
  userId: string;
  fromDate: string;
  toDate: string;
}) => {
  const response = await client.get(
    `${baseUrl}${GETUSERANALYTICS}/${userId}?fromDate=${fromDate}&toDate=${toDate}`
  );
  return response.data;
};

export const getDistributionForwards = async ({
  userId,
  page,
  size,
}: {
  userId: string;
  page: number;
  size: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETDISTRIBUTIONFORWARDS}/${userId}`,
    {
      params: {
        page,
        size,
      },
    }
  );
  return response.data;
};

export const getForwardRecipients = async ({
  messageId,
}: {
  messageId: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETFORWARDSRECIPIENTS}/${messageId}`
  );
  return response.data;
};

export const getMandatoryMessages = async ({
  userId,
  page,
  size,
}: {
  userId: string;
  page: number;
  size: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETMANDATORYMESSAGES}/${userId}`,
    {
      params: {
        page,
        size,
      },
    }
  );
  return response.data;
};

export const getMessageStatistics = async ({
  userId,
  page,
  size,
}: {
  userId: string;
  page: number;
  size: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETMESSAGESTATISTICS}/${userId}`,
    {
      params: {
        page,
        size,
      },
    }
  );
  return response.data;
};

export const getMessageRecipientsStats = async ({
  messageId,
}: {
  messageId: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETMESSAGERECIPIENTSSTATS}/${messageId}`
  );
  return response.data;
};

export const removeUser = async (userId: number) => {
  const response = await client.delete(`${baseUrl}/users/${userId}`);
  return response;
};

export const getLiteUsers = async () => {
  const response = await client.get(`${baseUrl}${GETLITEUSERS}`);
  return response.data;
};

export const getMandatoryReplyMessages = async ({
  userId,
  page,
  size,
}: {
  userId: string;
  page: number;
  size: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETMANDATORYREPLYMESSAGES}${userId}`,
    {
      params: {
        page,
        size,
      },
    }
  );
  return response.data;
};

export const getMessageReplyRecipientsStats = async ({
  messageId,
}: {
  messageId: number;
}) => {
  const response = await client.get(
    `${baseUrl}${GETREPLYRECIPIENTS}${messageId}`
  );
  return response.data;
};

export const activeUser = async ({ userId }: { userId: number }) => {
  const response = await client.put(`${baseUrl}${ACTIVATEUSER}${userId}`);
  return response;
};

export const deactiveUser = async ({ userId }: { userId: number }) => {
  const response = await client.put(`${baseUrl}${DEACTIVATEUSER}${userId}`);
  return response;
};

export const bulkUploadUsers = async ({ formData }: { formData: any }) => {
  const response = await client.post(`${baseUrl}${BULKINVITEUSERS}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response;
};
